<template>
    <thead class="thead-dark">
    <tr>
        <th
            v-for="header in headers"
            :class="{
                    'text-nowrap': true,
                    'text-underline': isHeaderSorted(header)
                }"
        >
            <div v-if="!!header.sort">
                    <span class="header-text icon mr-2">
                        <i :class="'fa '+ getSortIcon(header)"></i>
                    </span>
                <a href="#" @click.prevent="sortByHeader(header)"
                   :aria-label="getAriaLabel(header)">
                    {{ header.title }}
                </a>
            </div>
            <span v-else>
                    {{ header.title }}
                </span>
        </th>
    </tr>
    </thead>
</template>
<script>

    import {EventBus} from "../../mixins/event-bus";

    export default {
        name: 'table-headers',
        props: {
            headers: {
                type: Array,
                required: true,
                default() {
                    return [];
                }
            },
            id: {
              type: String,
            },
            sortColumn: {
                type: String,
                default() {
                    const firstSortable = this.headers.find((header) => header.sort);
                    return firstSortable ? firstSortable.column : '';
                }
            },
            sortTitle: {
                type: String,
                default() {
                    const firstSortable = this.headers.find((header) => header.sort);
                    return firstSortable ? firstSortable.title : '';
                }
            },
            sortOrder: {
                type: String,
                default() {
                    return 'asc';
                }
            },
            sortIcon: {
                type: Object,
                default() {
                    return {
                        'alpha': {
                            'asc': 'fa fa-sort-alpha-asc',
                            'desc': 'fa fa-sort-alpha-desc'
                        },
                        'numeric': {
                            'asc': 'fa fa-sort-numeric-asc',
                            'desc': 'fa fa-sort-numeric-desc'
                        }
                    };
                }
            }
        },
        data() {
            return {
                currentSortColumn: this.sortColumn,
                currentSortTitle: this.sortTitle,
                currentSortOrder: this.sortOrder
            };
        },
        methods: {
            isHeaderSorted(header) {
                return (this.currentSortColumn === header.column && this.currentSortTitle === header.title);
            },
            getSortIcon(header) {
                const sortOrder = this.isHeaderSorted(header) ? this.currentSortOrder : 'asc';
                return this.sortIcon[header.sort][sortOrder];
            },
            getAriaLabel(header) {
                const sortOrder = this.isHeaderSorted(header) ? this.currentSortOrder : 'desc';
                let sortText = sortOrder === 'asc' ? this.$lang('malejąco') : this.$lang('rosnąco');
                return this.$lang('Sortuj') + ' ' + sortText + ' ' + this.$lang('kolumnę') + ' ' + header.title;
            },
            emit() {
                EventBus.$emit('sortByColumn', {
                    column: this.currentSortColumn,
                    order: this.currentSortOrder,
                    id: this.id,
                });
            },
            sortByHeader(header) {
                if (this.currentSortColumn === header.column && this.currentSortTitle === header.title) {
                    this.currentSortOrder = ((this.currentSortOrder === 'asc') ? 'desc' : 'asc');
                } else {
                    this.currentSortColumn = header.column;
                    this.currentSortOrder = 'asc';
                }
                this.currentSortTitle = header.title;

                this.emit();
            }
        }
    }

</script>
